<template>

  <article class="c-entry">
    <h2>{{ content.title }}</h2>
    <div v-html="content.excerpt"></div>

    <div class="u-margin-top">
      <router-link class="c-btn c-btn--primary" :to="`/${$route.params.lang}/${content.uri}`">
        <span class="c-btn__arrow"></span>

        {{ $globals.labels.moreInfoLabel }}

        <span class="c-btn__hover">
          <svg svg-inline="" focusable="false" role="presentation" width="241" height="14" viewBox="0 0 241 14" xmlns="http://www.w3.org/2000/svg"><path d="M0 1c36.44 10.083 65.748 11.382 85.864 10.68 50.429-1.762 80.135-17.316 112.864-5.401 16.93 6.163 31.798 9.014 38.397 4.54 1.709-1.158 3.555-3.723 2.626-6.154" stroke="#F0C57B" fill="none" fill-rule="evenodd"/></svg>
        </span>
      </router-link>
    </div>

  </article>

</template>

<script>
export default {
  name: 'Entry',
  props: ['content'],

  methods: {
  }

}
</script>
